import { gql, TypedDocumentNode } from "@apollo/client";

import { FlowsIntegration, Maybe } from "types/generated";

type FlowsIntegrationData = {
  flowsIntegration: Maybe<
    Pick<
      FlowsIntegration,
      "organizationID" | "baseURL" | "organizationName" | "createdAt" | "updatedAt"
    >
  >;
};

export const GET_FLOWS_INTEGRATION: TypedDocumentNode<FlowsIntegrationData> = gql`
  query GetFlowsIntegration {
    flowsIntegration {
      organizationID
      baseURL
      organizationName
      createdAt
      updatedAt
    }
  }
`;
